<mat-card >
    <div class="title">{{'documents.titles.upload_employees' | translate}}</div>
    <mat-card-content>
        <form class="d-flex flex-column w-100 mt-3 mb-2" [formGroup]="documentForm" novalidate>


            <div class="justify-content-center" [ngClass]="{'d-none': selectedFile, 'd-flex': !selectedFile}">
                <a target="_blank" rel="noopener noreferrer" (click)="fileSelector.click()" class="pdf-link">
                    <mat-icon color="primary" class="pdf-icon mr-2">description</mat-icon>
                    <u>
                        {{'documents.download' | translate}}
                    </u>
                </a>
                <input #fileSelector type="file" hidden (change)="downloadDocument($event)" accept="application/xlsx" />
            </div>
            
            <mat-expansion-panel *ngIf="!selectedFile">
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    {{'employees.more' | translate }}
                  </mat-panel-title>
                  
                </mat-expansion-panel-header>
                <div class="d-flex flex-column justify-content-center w-100">
                
                    <mat-form-field appearance="outline"  *ngIf="countries.length > 1" >
                        <mat-select formControlName="country" [placeholder]="'notifications.message_creation.country'| translate" (selectionChange)="onSelectCountry($event)">
                            <mat-option *ngFor="let country of countries" [value]="country.id">
                                <img [src]="'assets/images/flags/' + country.code.toUpperCase() + '.png'" [alt]="" class="mr-1"> {{country['label_' + currentLang]}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>    
             
    
           
                    <button mat-flat-button color="primary" class="mb-3" (click)="onExportTemplate()">
                        <mat-icon>file_download</mat-icon>
                        {{ 'employees.download_template' | translate }}
                    </button>

                    <button mat-flat-button color="primary" class="mb-3" (click)="onOpenImportHistoryDialog()">
                        <mat-icon>history</mat-icon>
                        {{ 'employees.history' | translate }}
                    </button>
                </div>
            </mat-expansion-panel>
           

  

        </form>

        <div class="file-container mb-2" [hidden]="!selectedFile">
        <!--div class="file-container mb-2" -->    
            <div class="file-upload-progress mb-2" *ngIf="progress > 0">
                <mat-progress-bar mode="determinate" [value]="progress"></mat-progress-bar>
                <div class="progress-text">{{progress}} %</div>
            </div>
            <div class="file-infos">
                <div class="d-flex align-items-center">
                    <div class="file-name">
                        {{selectedFile?.name}}
                    </div>
                    <button mat-icon-button (click)="cancelFile()" color="primary" class="mx-0">
                        <mat-icon>cancel</mat-icon>
                    </button>
                </div>
                <button mat-flat-button class="mt-2" color="primary" (click)="uploadFile()" *ngIf="progress === 0">
                    <mat-icon>arrow_right</mat-icon>{{'documents.import' | translate}}
                </button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
